// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>

import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import classNames from 'classnames/bind';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles';

import { getData } from '../store/selectors';
import * as homeActions from '../store/actions';

import HomeNavigation from '../../../common/HomeNavigation/HomeNavigation';

import {
  BarcodeBlock,
  VideoBlock,
  RatingBlock,
  BenefitsBlock,
  CarbonBlock,
} from '../blocks';

class HomePage extends React.Component {
  state = {
    isHomePage: true,
  };

  componentDidMount() {
    this.props.requestHomePage();
  }

  render() {
    const { classes, data } = this.props;
    const { isHomePage } = this.state;
    return (
      <HomeNavigation isIndex isHomePage={isHomePage}>
        <section
          id={'main-text-container'}
          className={classNames(classes.section, classes.paddingRightZero)}
        >
          <BarcodeBlock
            title_line1={data.title_line1}
            title_line2={data.title_line2}
            isHomePage={isHomePage}
          />
        </section>
        <section id={'video-container'} className={classes.section}>
          <VideoBlock
            video_block_title={data.video_block_title}
            video_link={data.video_link}
          />
        </section>
        <section id={'rate-container'} className={classes.section}>
          <RatingBlock
            rating_block_title={data.rating_block_title}
            rating_block_description={data.rating_block_description}
            rating_block_carousel_interval={data.rating_block_carousel_interval}
            rating_panel={data.rating_panel}
          />
        </section>
        <section id={'benefits-container'} className={classes.section}>
          <BenefitsBlock images={data.images} />
        </section>
        <section
          id={'carbon-container'}
          className={classNames(classes.section, classes.paddingZero)}
        >
          <CarbonBlock
            carbon_block_title={data.carbon_block_title}
            carbon_block_description={data.carbon_block_description}
          />
        </section>
      </HomeNavigation>
    );
  }
}

HomePage.propTypes = {
  classes: PropTypes.object,
  requestHomePage: PropTypes.func,
  data: PropTypes.object,
};

HomePage.defaultProps = {
  classes: {},
  requestHomePage: () => { },
  data: {
    images: [],
    rate_panel: [],
  },
};

function mapStateToProps(state) {
  return {
    data: getData(state),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    requestHomePage: () => dispatch(homeActions.requestPageData()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(HomePage));
